import * as angular from "angular";

angular
  .module('bringoz.admin.shippers')
  .config(config);

/* @ngInject */
function config($stateProvider) {

  $stateProvider

    .state('shippers-list', {
      parent: 'bringoz.site',
      url: '/shippers',
      template: '<shippers-list-view></shippers-list-view>',
      controllerAs: 'vm',
      controller: function(triBreadcrumbsService, site) {
        triBreadcrumbsService.reset();
        triBreadcrumbsService.addCrumb({name: "Shippers", state: "shippers-list"});
        triBreadcrumbsService.addCrumb({name: "Shippers"});
      }
    })

    //Shipper details
    .state('shipper', {
      parent: 'bringoz.site',
      url: '/shipper/:id',
      abstract: true,
      template: '<shipper-detailed-view shipper="shipper"></shipper-detailed-view>',
      controllerAs: 'vm',
      controller: function ($scope, $shipper, triBreadcrumbsService, shipper, site) {

        $scope.shipper = shipper;
        $shipper(shipper.id).$bind($scope, 'shipper');

        triBreadcrumbsService.reset();
        triBreadcrumbsService.addCrumb({name: shipper.user.firstName + ' ' + shipper.user.lastName, ignoreTranslate: true});
        triBreadcrumbsService.addCrumb({name: 'Shippers', state: "shippers-list"});
        triBreadcrumbsService.addCrumb({name: 'Shippers'});

      },
      resolve : {
        shipper : function(site, $shipper, $stateParams) {
          return $shipper($stateParams.id).$instantGet();
          // return $shipper($stateParams.id).$asyncValue();
        }
      }
    })
    .state('shipper.preferences', {
      url: '/preferences',
      pageTrack: '/shipper/preferences',
      template: '<shipper-preferences id="$ctrl.shipper.id"></shipper-preferences>'
    })
    .state('shipper.accounts', {
      url: '/accounts',
      pageTrack: '/shipper/accounts',
      template: '<shipper-accounts-view id="$ctrl.shipper.id"></shipper-accounts-view>'
    })
    .state('shipper.contact', {
      url: '/contact',
      pageTrack: '/shipper/contact',
      template: '<contact-user-view user="$ctrl.shipper.user"></contact-user-view>'
    });
}
